/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useMutation } from '@apollo/client';
import PageForm from '../components/form';
import { PUBLISH_PAGE_TO_FALCON, UPDATE_PAGE } from '../../../queries/page';

interface IUpdatePageProps {
  data: any;
  setIsDrawerOpen: any;
  refetch: any;
}

export const UpdatePage: React.FC<IUpdatePageProps> = ({
  data,
  refetch,
  setIsDrawerOpen,
}) => {
  const [updatePage] = useMutation(UPDATE_PAGE, {
    update: async () => {
      await refetch();
    },
  });

  const [publishPageToFalcon] = useMutation(PUBLISH_PAGE_TO_FALCON, {
    update: async () => {
      await refetch();
    },
  });

  return (
    <PageForm
      data={data}
      mutateData={updatePage}
      publishPageToFalcon={publishPageToFalcon}
      setIsDrawerOpen={setIsDrawerOpen}
    />
  );
};
